export default "__VITE_ASSET__bf9569ad__"